@if(showError){
<div class="alert-html-container">
    <div class="w-100 h-100 position-relative">
        <span class="m-0 p-0" style="position: absolute; top:-1.3rem; right: -1.2rem;" role="button" (click)="hideError()">x</span>
        <span class="m-0 p-0" [innerHTML]="errorHtml"></span>
    </div>
</div>
}